import { useState } from 'react'

import { Spinner } from '@wartek-id/spinner'

import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import CardKinerjaSteps from 'app/KinerjaShared/components/CardKinerjaSteps'
import CardReferensi from 'app/KinerjaPage/components/CardReferensi'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import KepalaSekolahRootView from 'app/KinerjaPage/components/KepalaSekolahRootView'
import SimulationMode from 'app/KinerjaPage/components/SimulationMode'
import CardReferensiPenilaian from 'app/KinerjaPage/pages/PelaksanaanV2/CardReferensiPenilaian'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import CardPenilaianPeriodik from 'app/KinerjaShared/components/CardPenilaianPeriodik'
import DialogSelectSchoolPenilaianPeriodik from 'app/KinerjaPage/components/DialogSelectSchoolPenilaianPeriodik'
import useToggleSdkContext from 'utils/useToogleSdk'
import { useApiGetPenilaianPeriodikType } from 'api/kinerja/kepala-sekolah/penilaian-periodik'
import usePenilaianPeriodikTrackEvent from 'app/KinerjaShared/hooks/usePenilaianPeriodikTrackEvent'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'
import { AnnouncementBanner } from 'app/KinerjaShared/components/AnnouncementBanner'

interface BerandaKepalaSekolahPenilaiProps {
  isKinerjaPelaksanaanEnabled?: boolean
  isKinerjaPenilaianDemoEnabled?: boolean
}

const BerandaKepalaSekolahPenilai = ({
  isKinerjaPelaksanaanEnabled = false,
  isKinerjaPenilaianDemoEnabled = false,
}: BerandaKepalaSekolahPenilaiProps) => {
  const { isLoading, profile } = useRoleContext()
  const { periods, periodYear } = usePeriodContext()
  const { trackEventWithPtkId } = usePenilaianPeriodikTrackEvent()

  const { tipe } = useKinerjaTipe()
  const isPeriodResolved = Array.isArray(periods) && periods.length > 0
  const isNotReady = isLoading || !isPeriodResolved

  const [isSchoolSelectionDialogOpen, setIsSchoolSelectionDialogOpen] =
    useState(false)

  const toggleValue = useToggleSdkContext()
  const isPenilaianPeriodikEnabled =
    toggleValue?.['kinerja-penilaian-periodik-enabled'] && periodYear >= 2025

  const { data: periodicTypeData, isSuccess: isSuccessPeriodicType } =
    useApiGetPenilaianPeriodikType({
      params: { skpYear: periodYear, tipe },
      options: {
        enabled: isPenilaianPeriodikEnabled,
        staleTime: 60 * 60 * 1000, // 1 hour
        cacheTime: 60 * 60 * 1000, // 1 hour
      },
    })

  // ------------------
  // Penilaian periodik
  // ------------------
  const handleClickPenilaianPeriodikEntrypoint = () => {
    setIsSchoolSelectionDialogOpen(true)

    trackEventWithPtkId({
      activity_type: 'open_homepage',
      screen_name: 'penilaian_periodik',
      attributes: {
        year: periodYear,
        role: 'ks',
      },
    })
  }

  const handleClickPenilaianPeriodikSchool = () => {
    trackEventWithPtkId({
      activity_type: 'choose_satdik',
      screen_name: 'penilaian_periodik',
      attributes: {
        year: periodYear,
        role: 'ks',
      },
    })
  }

  return (
    <div className="pl-64">
      <KinerjaSidebar sticky activeMenu="ks-penilai" />
      <div className="p-6 flex flex-col gap-6 w-full">
        {periodYear === 2026 && (
          <AnnouncementBanner
            title="[Periode 2026] Kami memperbarui indikator Target Perilaku pada Praktik Kinerja Guru"
            description="Silakan cek kembali indikator target perilaku Guru di sekolah Anda. Diskusikan perubahan tersebut jika diperlukan."
          />
        )}
        {isNotReady ? (
          <div className="w-full flex justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            <KepalaSekolahRootView
              profile={profile}
              isKinerjaPelaksanaanEnabled={isKinerjaPelaksanaanEnabled}
              isLoading={isLoading}
            />
            {isSuccessPeriodicType && (
              <>
                <CardPenilaianPeriodik
                  periodicType={periodicTypeData.data.periodicType}
                  onCtaClick={handleClickPenilaianPeriodikEntrypoint}
                />

                <DialogSelectSchoolPenilaianPeriodik
                  isOpen={isSchoolSelectionDialogOpen}
                  onClickSchool={handleClickPenilaianPeriodikSchool}
                  onClose={() => setIsSchoolSelectionDialogOpen(false)}
                />
              </>
            )}
            {isKinerjaPenilaianDemoEnabled && <SimulationMode />}{' '}
          </>
        )}

        <CardReferensiPenilaian />

        <CardKinerjaSteps />

        <CardReferensi />
      </div>
    </div>
  )
}

export default BerandaKepalaSekolahPenilai
